import {
  ConsoleGetStartedPage,
  consoleCreditsQueryOptions,
  consoleKeysQueryOptions,
  consoleUsageQueryOptions,
} from "@/features/console";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/_modal/console/get-started")({
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleCreditsQueryOptions());
    void queryClient.ensureQueryData(consoleKeysQueryOptions());
    void queryClient.ensureQueryData(consoleUsageQueryOptions("30d"));
  },
  component: ConsoleGetStartedPage,
});
